
(function () {
  'use strict';

  if (window.WCTierViews && window.WCTierViews.__inited) return;

  

  var _cachedNoun = null;
  function getProductNoun() {
    if (_cachedNoun !== null) return _cachedNoun;
    var pi = document.querySelector('product-info');
    _cachedNoun = (pi && pi.dataset && pi.dataset.wcProductNoun) || 'shirts';
    return _cachedNoun;
  }

  var EVENT_NAME = (window.WCTier && window.WCTier.EVENT_NAME) || 'wc:tier-updated';

  var prevTierIndex = -2;
  var prevCount = -1;

  var prevBmsmCents = 0;

  

  
  function animateCount(el, fromCents, toCents, duration, formatter, useHTML) {
    if (!el) return;
    fromCents = Math.round(fromCents);
    toCents = Math.round(toCents);
    formatter = formatter || function (c) { return '$' + (c / 100).toFixed(2); };

    
    
    var write = useHTML
      ? function (s) { el.innerHTML = s; }
      : function (s) { el.textContent = s; };
    if (fromCents === toCents) {
      write(formatter(toCents));
      return;
    }
    if (typeof requestAnimationFrame !== 'function') {
      write(formatter(toCents));
      return;
    }
    var start = (typeof performance !== 'undefined' && performance.now)
      ? performance.now() : Date.now();
    var diff = toCents - fromCents;
    function tick(now) {
      var t = Math.min(1, (now - start) / duration);
      var ease = 1 - Math.pow(1 - t, 3); 
      var current = Math.round(fromCents + diff * ease);
      write(formatter(current));
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  
  
  function paintMounts(state) {
    document.querySelectorAll('[data-wc-tier-mount]').forEach(function (mount) {
      updateMount(mount, state);
    });
    document.querySelectorAll('[data-wc-tier-subline]').forEach(function (el) {
      paintSubline(el, state);
    });
    document.querySelectorAll('[data-wc-tier-sticky-text]').forEach(function (el) {
      paintStickyMsg(el, state);
    });
  }

  

  

  
  
  function paintHeaderBubble(state) {
    var anchor = document.getElementById('cart-icon-bubble');
    if (!anchor) return;

    
    var bubble = anchor.querySelector('.cart-count-bubble');
    if (bubble) {
      var visible = bubble.querySelector('span[aria-hidden="true"]');
      if (visible) {
        visible.textContent = state.count >= 100 ? '99+' : String(state.count);
      }
      var sr = bubble.querySelector('.visually-hidden');
      if (sr) {
        sr.textContent = state.count + ' item' + (state.count === 1 ? '' : 's') + ' in cart';
      }
    }

    
    var tierPill = anchor.querySelector('.wc-cart-tier-bubble');
    if (state.off > 0) {
      if (!tierPill) {
        tierPill = document.createElement('div');
        tierPill.className = 'wc-cart-tier-bubble';
        tierPill.setAttribute('aria-hidden', 'true');
        anchor.appendChild(tierPill);
      }
      tierPill.textContent = state.off + '% OFF';
    } else if (tierPill) {
      tierPill.parentNode.removeChild(tierPill);
    }
  }

  function applyState(state) {

    
    
    document.body.classList.toggle('wc-at-top-tier', !!state.atTop);

    var crossedUp = prevCount >= 0 && state.count > prevCount && state.count >= 1;
    if (crossedUp) {
      maybeShowCelebration(prevCount, state.count, state);
    }

    

    paintMounts(state);
    paintBmsmSavingsLine(state);
    paintHeaderBubble(state);

    if (prevTierIndex >= 0 && state.tierIndex > prevTierIndex) {
      var qty = state.tierIndex + 1;
      document.querySelectorAll(
        '[data-wc-tier-mount] [data-tier-qty="' + qty + '"]'
      ).forEach(function (el) {
        el.classList.add('is-just-crossed');
        setTimeout(function () { el.classList.remove('is-just-crossed'); }, 800);
      });
    }

    var stateChanged =
      (prevCount !== state.count) || (prevTierIndex !== state.tierIndex);
    prevTierIndex = state.tierIndex;
    prevCount = state.count;

    

    
    if (stateChanged) {
      setTimeout(function () { paintMounts(state); }, 220);
    }
  }

  function updateMount(mount, state) {
    var variant = mount.getAttribute('data-variant');
    if (variant === 'cart-bar') updateCartBar(mount, state);
    else                        updateTierItems(mount, state);
  }

  function updateTierItems(mount, state) {
    mount.querySelectorAll('[data-tier-qty]').forEach(function (el) {
      var qty = parseInt(el.getAttribute('data-tier-qty'), 10);
      var unlocked = state.count >= qty;
      var current  = (state.tierIndex + 1) === qty;
      el.classList.toggle('is-unlocked', unlocked);
      el.classList.toggle('is-current', current);
    });
  }

  function updateCartBar(mount, state) {
    updateTierItems(mount, state);

    var pct;
    if (state.count <= 0)      pct = 0;
    else if (state.count >= 6) pct = 100;
    else                       pct = Math.round((state.count / 6) * 100);

    var fill = mount.querySelector('[data-wc-tier-progress]');
    if (fill) {
      fill.style.width = pct + '%';
      fill.classList.toggle('is-full', pct >= 100);
      fill.setAttribute('data-tier-level', String(state.tierIndex < 0 ? 0 : state.tierIndex));
    }
  }

  
  
  function paintSubline(root, state) {
    var icon = root.querySelector('.wc-tier-subline__icon');
    var text = root.querySelector('.wc-tier-subline__text');
    if (!icon || !text) return;

    

    

    
    var noun = getProductNoun();
    var nounSingular = noun === 'shirts'   ? 'shirt'
                     : noun === 'stickers' ? 'sticker'
                     : 'item';

    var html;
    if (state.count === 0) {
      icon.textContent = '🔥';

      
      if (noun === 'shirts') {
        html = 'Mix any <strong>2+ shirts</strong> &rarr; unlock <strong>10% OFF</strong>';
      } else {
        html = 'Add <strong>2+ ' + noun + '</strong> &rarr; unlock <strong>10% OFF</strong>';
      }
    } else if (state.count === 1) {
      
      icon.textContent = '🔥';
      html = 'Add <strong>1 more ' + nounSingular + '</strong> &rarr; unlock <strong>10% OFF</strong>';
    } else if (state.atTop) {
      icon.textContent = '🎉';
      html = '<strong>50% OFF</strong> sitewide';
    } else {
      icon.textContent = '✓';
      html = '<strong>' + state.off + '% OFF</strong> unlocked &mdash; add 1 more for <strong>' + state.nextOff + '% OFF</strong>';
    }
    text.innerHTML = html;
  }

  
  
  function paintStickyMsg(el, state) {
    var n = state.count;
    var html;

    
    if (n === 0)      html = 'mix any 3 shirts = <em>20% OFF</em>';
    else if (n === 1) html = 'mix 2 more shirts = <em>20% OFF</em>';
    else if (n === 2) html = 'add 1 more shirt = <em>20% OFF</em>';
    else if (n === 3) html = 'add 1 more shirt = <em>30% OFF</em>';
    else if (n === 4) html = 'add 1 more shirt = <em>40% OFF</em>';
    else if (n === 5) html = 'add 1 more shirt = <em>50% OFF</em>';
    else              html = "you've unlocked <em>50% OFF</em> sitewide";
    el.innerHTML = html;

    var bar = el.closest ? el.closest('.wc-tier-sticky-bar') : null;
    if (bar) bar.classList.toggle('is-unlocked', state.atTop);
  }

  

  var activeTimers = [];
  function clearTimers() {
    activeTimers.forEach(clearTimeout);
    activeTimers = [];
  }

  

  function nextOffAt(c) {
    if (c >= 6) return 50;
    if (c < 1) return 10;
    return [10, 10, 20, 30, 40, 50][c]; 
  }

  function maybeShowCelebration(prev, now, state) {
    if (now < 1) return;

    

    
    
    if (now === 1 && (!state || (state.cartTotal || 0) < 2500)) return;

    clearTimers();

    
    
    var savedCents = (state && typeof state.bmsmSavingsCents === 'number')
      ? state.bmsmSavingsCents
      : 0;
    var savedDollars = (savedCents / 100).toFixed(2);

    

    
    var primaryHTML;
    if (now === 1) {
      primaryHTML =
        'Congrats! You<br>got a <em>free gift</em>!' +
        '<span class="visually-hidden" data-wc-celebration-sr></span>';
    } else {
      primaryHTML =
        'You just saved<br>' +
        '<strong>$<span data-wc-celebration-counter aria-hidden="true">0.00</span>!</strong>' +
        '<span class="visually-hidden" data-wc-celebration-sr></span>';
    }

    

    
    var midHTML = '';
    var secondaryHTML = '';
    if (now === 6) {
      secondaryHTML = "You've unlocked<br><em>50% OFF</em> sitewide";
    } else if (now < 6) {
      secondaryHTML = 'Add 1 more shirt<br>to unlock <em>' + nextOffAt(now) + '% OFF</em>';
    }

    

    var attempt = 0;
    function tryMount() {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) {
        if (attempt++ < 10) {
          activeTimers.push(setTimeout(tryMount, 100));
        }
        return;
      }
      mountOverlay(drawer);
    }

    function mountOverlay(drawer) {
      if (getComputedStyle(drawer).position === 'static') {
        drawer.style.position = 'relative';
      }

      var overlay = drawer.querySelector('.wc-tier-celebration');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'wc-tier-celebration';
        overlay.setAttribute('aria-live', 'polite');
        overlay.innerHTML =
          '<div class="wc-tier-celebration__msg wc-tier-celebration__msg--primary"></div>' +
          '<div class="wc-tier-celebration__msg wc-tier-celebration__msg--mid"></div>' +
          '<div class="wc-tier-celebration__msg wc-tier-celebration__msg--secondary"></div>';
        drawer.appendChild(overlay);
      }
      overlay.querySelector('.wc-tier-celebration__msg--primary').innerHTML = primaryHTML;
      overlay.querySelector('.wc-tier-celebration__msg--mid').innerHTML = midHTML;
      overlay.querySelector('.wc-tier-celebration__msg--secondary').innerHTML = secondaryHTML;

      

      overlay.classList.remove('is-stage-mid', 'is-stage2', 'is-visible');
      
      void overlay.offsetWidth;
      overlay.classList.add('is-visible');

      

      
      activeTimers.push(setTimeout(function () {
        var counter = overlay.querySelector('[data-wc-celebration-counter]');
        if (counter) {
          animateCount(counter, 0, savedCents, 800, function (c) {
            return (c / 100).toFixed(2);
          });
        }
      }, 200));
      activeTimers.push(setTimeout(function () {
        var sr = overlay.querySelector('[data-wc-celebration-sr]');
        if (!sr) return;
        sr.textContent = (now === 1)
          ? 'Congrats, you got a free gift.'
          : 'You just saved $' + savedDollars + '.';
      }, 1100));

      
      
      spawnConfetti(overlay, 14);

      
      if (now > 6) {

        activeTimers.push(setTimeout(function () {
          overlay.classList.remove('is-visible');
        }, 1550));
      } else {

        
        
        activeTimers.push(setTimeout(function () {
          overlay.classList.add('is-stage2');
        }, 1550));
        activeTimers.push(setTimeout(function () {
          overlay.classList.remove('is-visible');
        }, 2750));
      }
    }

    tryMount();
  }

  

  

  function paintBmsmSavingsLine(state) {
    var el = document.querySelector('[data-wc-bmsm-savings]');
    if (!el) {

      prevBmsmCents = 0;
      return;
    }

    var newCents = parseInt(el.getAttribute('data-wc-cents'), 10) || 0;
    if (newCents === prevBmsmCents) return;
    animateCount(el, prevBmsmCents, newCents, 600);
    prevBmsmCents = newCents;
  }

  

  
  
  var ATC_FLASH_MS = 700;
  function flashAtcAddedOn(btn) {
    if (!btn) return;
    if (btn.dataset.wcFlashing === '1') return; 
    var label = btn.querySelector('.wc-atc-btn__text');
    if (!label) return;

    btn.dataset.wcFlashing = '1';
    btn.classList.add('wc-atc-btn--just-added');
    var original = label.textContent;
    label.textContent = '✓ Added!';

    setTimeout(function () {
      btn.classList.remove('wc-atc-btn--just-added');

      if (label.textContent === '✓ Added!') {
        label.textContent = original;
      }
      btn.dataset.wcFlashing = '0';
    }, ATC_FLASH_MS);
  }

  function bindAtcClickFlash() {
    document.addEventListener('click', function (e) {

      var btn = e.target.closest && e.target.closest('.wc-atc-btn');
      if (!btn) return;
      
      if (btn.disabled) return;
      if (btn.getAttribute('aria-disabled') === 'true') return;
      if (btn.classList.contains('loading')) return;
      flashAtcAddedOn(btn);
    }, true); 
  }

  

  var CONFETTI_COLORS = ['#FFD700', '#cc0000', '#fff', '#2d8a4e'];
  function spawnConfetti(parent, count) {
    if (!parent) return;
    var existing = parent.querySelectorAll('.wc-confetti');
    existing.forEach(function (el) { el.remove(); });
    for (var i = 0; i < count; i++) {
      var dot = document.createElement('span');
      dot.className = 'wc-confetti';
      var angle = (Math.PI * 2) * (i / count) + (Math.random() - 0.5) * 0.6;
      var distance = 90 + Math.random() * 90;
      var dx = Math.cos(angle) * distance;
      var dy = Math.sin(angle) * distance - 20; 
      var rot = (Math.random() * 720 - 360) + 'deg';
      var color = CONFETTI_COLORS[i % CONFETTI_COLORS.length];
      dot.style.setProperty('--dx', dx.toFixed(0) + 'px');
      dot.style.setProperty('--dy', dy.toFixed(0) + 'px');
      dot.style.setProperty('--rot', rot);
      dot.style.setProperty('--bg', color);
      dot.style.animationDelay = (i * 12) + 'ms';
      parent.appendChild(dot);
    }
    
    setTimeout(function () {
      parent.querySelectorAll('.wc-confetti').forEach(function (el) { el.remove(); });
    }, 1700);
  }

  
  
  function initStickyBar() {
    var ladder = document.querySelector('[data-wc-tier-ladder-anchor]');
    var bar    = document.querySelector('[data-wc-tier-sticky-bar]');
    if (!ladder || !bar) return;

    function check() {
      var headerH = parseInt(
        getComputedStyle(document.documentElement)
          .getPropertyValue('--wc-header-height') || '64',
        10
      ) || 64;

      

      
      
      var trigger = false;
      if (window.innerWidth >= 750) {
        var grid = document.querySelector('#product-grid');
        if (grid) {
          trigger = grid.getBoundingClientRect().top <= headerH;
        }
      } else {
        trigger = ladder.getBoundingClientRect().bottom <= headerH;
      }
      bar.classList.toggle('is-visible', trigger);
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  function setHeaderHeight() {

    

    
    var sticky = document.querySelector('sticky-header');
    var stickyInner = sticky ? sticky.querySelector('.header-wrapper') || sticky : null;
    var el = stickyInner
          || document.querySelector('.shopify-section-group-header-group')
          || document.querySelector('.section-header');
    if (!el) return;

     
     
    var buffer = window.innerWidth >= 990 ? -4 : -3;
    var h = Math.round(el.getBoundingClientRect().height) + buffer;
    document.documentElement.style.setProperty('--wc-header-height', h + 'px');
  }

  function watchCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var obs = new MutationObserver(function () {
      if (drawer.classList.contains('active') || drawer.classList.contains('is-open')) {
        if (window.WCTier && typeof window.WCTier.recompute === 'function') {
          window.WCTier.recompute();
        } else if (window.WCTier && typeof window.WCTier.getState === 'function') {
          var s = window.WCTier.getState();
          if (s) paintMounts(s);
        }
      }
    });
    obs.observe(drawer, { attributes: true, attributeFilter: ['class'] });

    document.querySelectorAll('#cart-icon-bubble, [data-cart-open], a[href="/cart"]').forEach(function (b) {
      b.addEventListener('click', function () {
        setTimeout(function () {
          if (window.WCTier && typeof window.WCTier.recompute === 'function') {
            window.WCTier.recompute();
          }
        }, 50);
      });
    });
  }

  function init() {
    document.addEventListener(EVENT_NAME, function (e) { applyState(e.detail); });
    initStickyBar();
    watchCartDrawer();
    setHeaderHeight();

    

    var headerHeightRaf = 0;
    function scheduleHeaderHeight() {
      if (headerHeightRaf) return;
      headerHeightRaf = requestAnimationFrame(function () {
        headerHeightRaf = 0;
        setHeaderHeight();
      });
    }
    window.addEventListener('resize', setHeaderHeight);
    window.addEventListener('scroll', scheduleHeaderHeight, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(setHeaderHeight);

    if (window.WCTier && typeof window.WCTier.getState === 'function') {
      var s = window.WCTier.getState();
      if (s) {
        prevCount = s.count;
        prevTierIndex = s.tierIndex;
        paintMounts(s);
      }
    }

    bindAtcClickFlash();

    window.WCTierViews = { __inited: true, paintMounts: paintMounts, animateCount: animateCount };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();